module.exports = __webpack_public_path__ + "img/sc_head.d9890fba.png";